import { FEATURE_DESCRIPTIONS, FEATURE_DISPLAY_NAMES, MESSAGE_TEMPLATES } from '../constants/alerts';
import type { Alert } from '../models/alert';

/**
 * Expands the message template for an alert by substituting `{placeholders}`
 * with values from `alert.parameters`. A `featureKey` parameter is
 * additionally mapped to a `featureDisplayName` via {@link FEATURE_DISPLAY_NAMES}
 * and a `featureDescription` via {@link FEATURE_DESCRIPTIONS}. Missing
 * placeholders are left as-is (e.g. `"{maintenanceStart}"`).
 */
export const renderAlertMessage = (alert: Alert): string => {
  const template = MESSAGE_TEMPLATES[alert.messageKey] ?? '';
  const params = alert.parameters ?? {};
  const expanded: Record<string, string> = { ...params };
  if (params.featureKey) {
    expanded.featureDisplayName = FEATURE_DISPLAY_NAMES[params.featureKey] ?? params.featureKey;
    if (FEATURE_DESCRIPTIONS[params.featureKey] && !expanded.featureDescription) {
      expanded.featureDescription = FEATURE_DESCRIPTIONS[params.featureKey];
    }
  }
  return template.replace(/\{(\w+)\}/g, (_, name) => expanded[name] ?? `{${name}}`);
};
